import React from 'react'

function InvBizRes() {
    return (
        <>
             <head style={{all:'initial'}}>
                <title>رخصة استثمار للأجانب</title>
                <meta name="description" content="رخصة استثمار للأجانب"/>
                <meta name="keywords" content="رخصة استثمار للأجانب" />
            </head>
            <div style={{
                padding: '50px',
                fontSize: '15px',
                lineHeight: '1.6',
                textAlign: 'right',
                direction: 'rtl'
            }}>
                <p style={{ marginBottom: '20px' }}>
                    يستهدف هذا المنتج المستثمرين الراغبين في الاستثمار في
                    الأنشطة الاقتصادية بالسعودية.
                </p>

                <p style={{ marginBottom: '20px' }}>
                    إذ تُعد المملكة أكبر سوق في المنطقة بفضل اقتصادها المتين
                    وقاعدتها السكانية الكبيرة. كما تحظى بمعدلات استثمار مرتفعة
                    بفضل موقعها الاستراتيجي المتميز الذي يربط القارات الثلاث،
                    وتمتاز بيئتها الاستثمارية بمواكبة احتياجات المستقبل. ويعمل
                    المنتج على دعم استقرار المستثمرين وتمكين أعمالهم من أجل
                    تحقيق نتائج إيجابية طموحة.
                </p>

                <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        fontSize: '16px'
                    }}>
                        المزايا العامة:
                    </h3>
                    <ul style={{
                        listStyleType: 'disc',
                        paddingRight: '20px',
                        margin: 0
                    }}>
                        <li style={{ marginBottom: '8px' }}>الإقامة في السعودية مع الأسرة، والتي تشمل الوالدين والأزواج والأبناء الذين تقل أعمارهم عن 25 عامًا.</li>
                        <li style={{ marginBottom: '8px' }}>الانتقال من منشأة إلى أخرى بحرية.</li>
                        <li style={{ marginBottom: '8px' }}>الإعفاء من المقابل المالي المقرر على الوافدين والمرافقين.</li>
                        <li style={{ marginBottom: '8px' }}>حملة الإقامة المميزة وأفراد أسرهم يمكنهم الخروج من السعودية والعودة إليها دون اشتراط تأشيرة.</li>
                        <li style={{ marginBottom: '8px' }}>إصدار تأشيرات زيارة للأقارب.</li>
                        <li style={{ marginBottom: '8px' }}>المساواة مع المواطنين ومواطني دول مجلس التعاون في المنافذ.</li>
                        <li style={{ marginBottom: '8px' }}>العمل في منشآت القطاع الخاص والانتقال بينها للزوج والزوجة والأبناء.</li>
                        <li style={{ marginBottom: '8px' }}>مزاولة الأعمال التجارية وفقًا لنظام الاستثمار.</li>
                        <li>تملُّك العقارات والانتفاع بها.</li>
                    </ul>
                </div>

                <div>
                    <h3 style={{
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        fontSize: '16px'
                    }}>
                        المزايا الخاصة:
                    </h3>
                    <ul style={{
                        listStyleType: 'disc',
                        paddingRight: '20px',
                        margin: 0
                    }}>
                        <li>الحصول مباشرةً على الإقامة المميزة الدائمة.</li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default InvBizRes